<!--eslint-disable-->
<template>
    <div class="login-container">
        <img class="leq-logo" src="logo-leq-horiz.bmp" 
        alt="Logo Leblon Equities">
        <div class="login">
            <div class="login-card">
                <div class="login-header">
                    <h1 class="header">Login</h1>
                </div>
                <div class="login-container">
                    <el-input v-model="email" placeholder="Email" @blur="checkEmail"></el-input><br>
                </div>
                <div class="login-container">
                    <el-input v-model="password" placeholder="Password" show-password></el-input><br>
                </div>
                
                <el-alert v-show="visible" :title="errorMessage" type="error" @close="changeVisible" show-icon center>
                    <p class="el-alert__description" v-show="isToCreateAccount"> Clique <router-link to='/signUp'>aqui</router-link> para criar um novo acesso. </p>
                    <p class="el-alert__description" v-show="forgottenPassword">Esqueceu sua senha? Clique <a @click="passwordEmail">aqui</a> </p>
                </el-alert>
                
                <div class="login-container">
                    <el-button class="connect" type="primary" @click="login" icon="el-icon-message" round>Login com seu email</el-button>
                </div>
            </div>
            
            <div class="login-hr-text-container">
                <span class="login-hr-text">ou</span>
            </div>
            
            <div class="login-social-card">
                <div class="login-container">
                    <el-button class="connect google-button" type="primary" @click="googleLogin" round>
                        <span>Login com Google</span>
                    </el-button>
                </div>
                <div class="login-container">
                    <el-button class="connect facebook-button" type="primary" @click="facebookLogin" round>
                        <span>
                            Login com Facebook
                        </span>
                    </el-button>
                </div>
            </div>
            
            <div class="login-footer">
                <p class="footer">Não possui uma conta? Você pode criar uma <router-link to="/signUp">aqui</router-link>.</p>
                
                <p class="footer"><router-link to="/forgotPassword">Esqueceu sua senha?</router-link>.</p>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import firebase from 'firebase/app'
    import fb from '@/services/firebaseConfig'
    import axios from 'axios'
    
    const db = fb.db
    const app = fb.app

    export default {
        name: 'login',
        data() {
            return {
                email: '',
                password: '',
                errorMessage: '',
                descriptionError: '',
                isToCreateAccount: false,
                forgottenPassword: false,
                visible: false,
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                errorCode: {
                    "auth/invalid-email": "E-mail fora do formato padrão.",
                    "auth/user-disabled": "Este e-mail está desabilitado. Entre em contato com o administrador da página.",
                    "auth/user-not-found": "Não foi encontrado usuário com este endereço de e-mail.",
                    "auth/wrong-password": "Senha inválida."
                }
            };
        },
        methods: {
            login: function() {
                firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
                    () => {
                        var user = firebase.auth().currentUser
                        
                        if(!user.emailVerified) {
                            this.errorMessage = "Por favor, confirme o seu e-mail"
                            this.isToCreateAccount = false
                            this.visible = true
                        }
                        else {
                            this.$router.replace('home')
                        }
                    },
                    (err) => {
                        this.isToCreateAccount = (err.code == "auth/user-not-found")
                        this.forgottenPassword = (err.code == "auth/wrong-password")
                        this.errorMessage = this.errorCode[err.code]
                        this.visible = true
                    }
                );
            },
           async googleLogin() {
               
                const provider = new firebase.auth.GoogleAuthProvider();
                let userCredential = await firebase.auth().signInWithPopup(provider)
                this.$router.replace('home')
            },
            async facebookLogin() {
                
                const provider = new firebase.auth.FacebookAuthProvider();
                await firebase.auth().signInWithPopup(provider)
                this.$router.replace('home')
            },
            changeVisible() {
                this.visible = false
            },
            checkEmail() {
                this.visible =  !this.reg.test(this.email) && (this.email != "");
                this.errorMessage = "E-mail fora do formato padrão."
            },
            passwordEmail() {
                firebase.auth().sendPasswordResetEmail(this.email).then(
                    () => {
                        this.$alert('Foi enviado um e-mail de alteração de senha.')
                    },
                    () => {
                        this.$alert('Ocorreu um erro. Por favor, entre em contato com o administrador.')
                    }
                )
            }
        }
    }
</script>

<style scoped>
    .leq-logo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        padding: 70px 0;
    }
    .login {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: 400px;
        margin: 0 auto;
    }
    .login-card {
        width: 100%;
        text-align: center;
        justify-content: center;
    }
    .login-social-card {
        width: 100%;
        text-align: center;
        justify-content: center;
    }
    .header {
        align-items: center;
        justify-content: center;
    }
    .login-email-senha{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .login-container {
        margin-bottom: 15px;
    }
    .login-header {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .connect {
        margin-top: 10px;
        width: 100%;
        font-size: 12.5px;
        line-height: 0.5;
        cursor: pointer;
    }
    .google-button {
        background-color: #d04949;
    }
    .facebook-button {
        background-color: #1f6ebf;
    }
    .login-hr-text-container {
        padding: 25px 0;
        margin: 0;
        line-height: 1;
        font-size: 90%;
    }
    .login-hr-text {
        padding: 0 12.5;
    }
    p {
        margin-top: 20px;
        /*font-size: 13px;*/
        text-align: center;
    }
    p a {
        text-decoration: underline;
        cursor: pointer;
    }
    .login-header h1 {
        font-family: Merriweather, serif;
        font-weight: 500;
        line-height: 1.35;
        color: #505050;
    }
    .login-footer {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .footer {
        align-items: center;
        justify-content: center;
    }
    .login-footer p {
        font-family: Merriweather, serif;
        font-weight: 50;
        line-height: 1.35;
        color: #505050;
    }
</style>
